import React from "react";
import { Card, Typography, Tooltip, Skeleton, Button } from "antd";
import "./ComparisonCard.css";
import { formatNumber } from "../../shared/utils";
import { Box } from "@mui/system";
import AmazonLogo from "../../assests/Images/amazon.png";
import WalmartLogo from "../../assests/Images/walmart.png";
import TargetLogo from "../../assests/Images/target.png";
import BestBuyLogo from "../../assests/Images/best_buy1.png";
import HomeDepotLogo from "../../assests/Images/homedepot1.png";
import KrogerLogo from "../../assests/Images/kroger.png";
import WayfairLogo from "../../assests/Images/wayfair1.png";
import { trackingService } from "../../services/api/trackingService.js";
const { Title } = Typography;
const storeMeta = {
    Amazon: { logo: AmazonLogo, color: "#FF9900" },
    Walmart: { logo: WalmartLogo, color: "#0071ce" },
    Target: { logo: TargetLogo, color: "#cc0000" },
    BestBuy: { logo: BestBuyLogo, color: "#cc0000" },
    Bestbuy: { logo: BestBuyLogo, color: "#cc0000" },
    Homedepot: { logo: HomeDepotLogo, color: "#cc0000" },
    HomeDepot: { logo: HomeDepotLogo, color: "#cc0000" },
    Kroger: { logo: KrogerLogo, color: "#cc0000" },
    Wayfair: { logo: WayfairLogo, color: "#cc0000" },
};

const handleProductClick = (storeData,phoneNumber) => {
  console.log("phoneNumber",phoneNumber)
  if (phoneNumber) {
    trackingService.trackProductClick(phoneNumber, {
      product_id: storeData?.key,
      product_title: storeData?.title,
      store: storeData.store,
      price: storeData.price,
      link: storeData.link,
      sort_option: "comparison product",
    });
  }
};

const ComparisonProductCard = ({product = {}, isLabel, labels,bestValue,productIndex,partialData,featureKey,phoneNumber,unitValue}) => {

    // Handle product click tracking

  return (
    <Card
      className={`top-pick-card comparison-product-card ${
        productIndex === 2 ? "highlighted" : isLabel ? "comparison-product-card-label-border" : ""}`}
      style={{
        position: "relative",
        paddingBottom: !isLabel ? "50px" : "0" // Add space for button
      }}
      cover={
        <div className="comparison-card-cover">
          {(productIndex === 0 || productIndex === 1 || productIndex === 2) && (
            <div
              style={{
                position: "absolute",
                top: productIndex === 2 ? "-31px" : "-30px",
                left: "50%",
                transform: "translateX(-50%)",
                // background: productIndex === 0 ? "#ff1493" : productIndex === 1 ? "#00d4d4" : "#005cff",
                background: "black",

                // color: productIndex === 0 ? "white" : productIndex === 1 ? "black" : "white",
                color:"white",
                fontSize: "10px",
                fontWeight: "bold",
                padding: "2px 0px",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                zIndex: 10,
                width: "95%"
              }}
            >
              {productIndex === 0 ? "Top Rated" : productIndex === 1 ? "Budget" : "Best Value"}
            </div>
          )}
          <div
            style={{
              width: "clamp(30px, 66%, 60px)",
              height: "clamp(30px, 50%, 60px)",
              margin: "0 auto",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              visibility: isLabel ? "hidden" : "visible"
            }}
          >
            {!product?.image && !bestValue?.image ? (
              <Skeleton.Image active style={{ width: 60, height: 60, borderRadius: 6 }} />
            ) : (
              <img
                src={bestValue?.image ? bestValue.image : Array.isArray(product?.image) ? product?.image?.[0] : product?.image}
                alt={bestValue?.title || product?.title}
                style={{
                  width: "100%",
                  height: "60px",
                  objectFit: "contain",
                  borderRadius: "6px"
                }}
              />
            )}
          </div>
        </div>
      }
    >
      <div style={{ textAlign: "center", overflow: "hidden", width: "100%" }}>
        <Tooltip placement="top" title={bestValue?.title || product?.title}>
          {bestValue?.title || product?.title || isLabel ? (
            <Title
              level={5}
              style={{
                margin: isLabel ? "0 0 clamp(7px, 1%, 12px) 0" : "0 0 clamp(9px, 1%, 12px) 0",
                fontSize: "10px",
                lineHeight: "1.3",
                fontWeight: 500,
                color: !bestValue?.title && !product?.title ? "white" : "#333",
                wordBreak: "break-word",
                whiteSpace: "normal",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                height: "28px",
                padding: "0px 5px"
              }}
            >
              {bestValue?.title || product?.title}
            </Title>
          ) : (
            <Skeleton.Input active size="small" block style={{ width: "100%", height: "31px", borderRadius: "0", marginBottom: "5px" }} />
          )}
        </Tooltip>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: "clamp(6px, 1%, 12px)",
            flexWrap: "nowrap",
            overflow: "hidden",
            width: "100%"
          }}
        >
          {!isLabel && (
            <Box direction="vertical" size={1} style={{ alignItems: "center", minWidth: 0, marginBottom: "6px", width: "100%" }}>
              {!bestValue?.rating && !product?.rating ? (
                bestValue?.rating == 0 ?
                <Typography
                  className="top-pick-text"
                  style={{
                    fontSize: "10px",
                    wordBreak: "break-word",
                    margin: !bestValue?.rating && !product?.rating ? "0px" : productIndex === 2 ? "-1px 0px clamp(7px, 1%, 12px)" : "0px 0px clamp(7px, 1%, 12px)",
                    lineHeight: "1.3",
                    fontWeight: "500",
                    color: !bestValue?.rating && !product?.rating ? "white" : "rgb(51, 51, 51)",
                    width: "100%",
                    padding: "7.4px"
                  }}
                >   n/a</Typography>
                :  <Skeleton.Input active size="small" block style={{ width: "100%", height: "23px", borderRadius: "0", marginBottom: "5px" }} />
               ) : (
                <Typography
                  className="top-pick-text"
                  style={{
                    fontSize: "10px",
                    wordBreak: "break-word",
                    margin: !bestValue?.rating && !product?.rating ? "0px" : productIndex === 2 ? "-1px 0px clamp(7px, 1%, 12px)" : "0px 0px clamp(7px, 1%, 12px)",
                    lineHeight: "1.3",
                    fontWeight: "500",
                    color: !bestValue?.rating && !product?.rating ? "white" : "rgb(51, 51, 51)",
                    width: "100%",
                    padding: "4px"
                  }}
                >
                  {bestValue?.rating
                    ? `${Math.floor(bestValue?.rating * 10) / 10}  ⭐ (${formatNumber(bestValue?.reviews)})`
                    : product?.rating
                    ? `${Math.floor(product?.rating * 10) / 10}  ⭐ (${formatNumber(product?.reviews)})`
                    : null}
                </Typography>
              )}

              {!bestValue?.price && !bestValue?.price != 0 && !product?.price ? (
                <Skeleton.Input active size="small" block style={{ width: "100%", height: "21px", borderRadius: "0", marginBottom: "5px" }} />
              ) : (
                <Typography
                  className="top-pick-text"
                  style={{
                    fontSize: "10px",
                    wordBreak: "break-word",
                    margin: !bestValue?.price && !product?.price ? "-4px" : partialData?.length > 0 ? "0px 0px clamp(5px, 1%, 12px)" : "0px 0px clamp(9px, 1%, 12px)",
                    lineHeight: "1.3",
                    fontWeight: "500",
                    color: !bestValue?.price && !product?.price ? "white" : "rgb(51, 51, 51)",
                    background: "#ededed",
                    width: "100%",
                    padding: "4px"
                  }}
                >
                  {bestValue?.price ? `$ ${Number(bestValue?.price).toFixed(2)}` : product?.price ? `$ ${Number(product?.price).toFixed(2)}` : null}
                </Typography>
              )}

              {!bestValue?.unit_price ? (
                <Skeleton.Input active size="small" block style={{ width: "100%", height: "20px", borderRadius: "0", marginBottom: "5px" }} />
              ) : bestValue?.unit !="count" ? (
                <Typography
                  key={product?.[`price_value`]}
                  className="top-pick-text"
                  style={{
                    fontSize: "10px",
                    wordBreak: "break-word",
                    margin: !bestValue?.unit_price && !product?.price ? "-4px" : "0px 0px clamp(9px, 1%, 12px)",
                    lineHeight: "1.3",
                    fontWeight: "500",
                    color: !bestValue?.unit_price && !product?.price ? "white" : "rgb(51, 51, 51)",
                    width: "100%",
                    padding: "4px"
                  }}
                >
                  {bestValue?.unit_price ?`$ ${Number(bestValue?.unit_price).toFixed(2)}/${bestValue?.unit}`:  product?.[`price_value`] ? `$ ${Number(product?.[`price_value`]).toFixed(2)}` : <Skeleton.Input active size="small" block style={{ width: "100%",height:"20px",borderRadius:"0" }} /> }
                </Typography>
              ): "" }

              {[1, 2].map((i) =>
                partialData?.length > 0 ? (
                  <Typography key={i} className="top-pick-text" style={{ fontSize: "10px", whiteSpace: "nowrap", margin: "0px 0px clamp(3px, 1%, 12px)", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold", width: "100%" }}>
                    <Skeleton.Input active size="small" block style={{ width: "100%", height: "20px", borderRadius: "0" }} />
                  </Typography>
                ) : product[`feature_${i}_value`] ? (
                  <Typography
                    key={i}
                    className="top-pick-text"
                    style={{
                      fontSize: "10px",
                      wordBreak: "break-word",
                      margin: "0px 0px clamp(8px, 1%, 12px)",
                      lineHeight: "1.3",
                      fontWeight: "500",
                      color: "rgb(51, 51, 51)",
                      width: "100%",
                      background: i % 2 !== 0 ? "#ededed" : "white",
                      padding: "4px"
                    }}
                  >
                    {product[`feature_${i}_value`]}
                  </Typography>
                ) : (
                  <Skeleton.Input key={i} active size="small" block style={{ width: "100%", height: "20px", borderRadius: "0" }} />
                )
              )}

              {(productIndex === 0 || productIndex === 1 || productIndex === 2) && (
                <div
                  style={{
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    // background: productIndex === 0 ? "#ff1493" : productIndex === 1 ? "#00d4d4" : "#005cff",
                    background:"#ededed",
                    color:"black",
                    // color: productIndex === 0 ? "white" : productIndex === 1 ? "black" : "white",
                    fontSize: "10px",
                    fontWeight: "bold",
                    padding: "2px",
                    borderRadius: "0px 0px 4px 4px",
                    whiteSpace: "nowrap",
                    zIndex: 10,
                    height: "40px",
                    width: productIndex === 2 ? "103%" : "101%",
                    wordWrap: "break-word",
                    alignContent: "center",
                    paddingLeft: "10px",
                    whiteSpace: "break-spaces",
                    paddingRight: "10px"
                  }}
                >
                  {product?.["best_for_value"]}
                </div>
              )}

              {/* NEW BUTTON ROW */}
              {partialData?.length <= 0 &&
              <div
                style={{
                  position: "absolute",
                  bottom: "4px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "100%",
                  zIndex: 10,
                  marginBottom:"-40px"
                }}
              >
                {/* <a href={bestValue?.link} target="_blank"> */}
                <Button
                  type="primary"
                  size="small"
                  block

                  style={{
                    fontSize: "10px",
                    fontWeight: "600",
                    height: "28px",
                    borderRadius: "4px",
                    // border: productIndex === 0 ? "1px solid #ff1493" : productIndex === 1 ? "1px solid #00d4d4" : "1px solid #005cff",
                    // background:"white",
                    background:"#00d4d4",
                    color: "black",
                    fontSize:"12px",
                    height:"44px",
                    boxShadow:"none"
                  }}
                  onClick={() => {
    handleProductClick(bestValue, phoneNumber);
    window.open(bestValue?.link, "_blank");
  }}
                >
                 <span style={{whiteSpace:"pre-line"}}>Open in {bestValue?.store}</span>
                   {/* <img
                      src={storeMeta?.[bestValue?.store]?.logo }
                      alt={bestValue?.store}
                      style={{ width: 12, height: 12 }}
                    /> */}
                </Button>
                {/* </a> */}
              </div>
              }
            </Box>
          )}
        </div>

        {isLabel && (
          <Box direction="vertical" size={1} style={{ alignItems: "flex-start", minWidth: 0, marginTop: "2px", marginBottom: "6px" }}>
            <Typography
                key={labels?.[`quality_description`]}
              className="top-pick-text"
              style={{
                fontSize: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: "bold",
                lineHeight: "1.3",
                width: "100%",
                margin: "0px 0px clamp(8px, 1%, 12px)",
                padding: "4px",
                textAlign: "left"
              }}
            >
              <Tooltip title="Quality">Quality</Tooltip>
            </Typography>

            <Typography
                key={labels?.[`price_description`]}
              className="top-pick-text"
              style={{
                fontSize: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: "bold",
                lineHeight: "1.3",
                width: "100%",
                margin: "0px 0px clamp(9px, 1%, 12px)",
                padding: "4px",
                background: "#ededed",
                textAlign: "left"
              }}
            >
              <Tooltip title="Price">Price</Tooltip>
            </Typography>
            {unitValue !== "count" &&
            <Typography
                key={labels?.[`price_description`]}
              className="top-pick-text"
              style={{
                fontSize: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: "bold",
                lineHeight: "1.3",
                width: "100%",
                margin: "0px 0px clamp(9px, 1%, 12px)",
                padding: "4px",
                textAlign: "left"
              }}
            >
              <Tooltip title="Price/Unit">Price/Unit </Tooltip>
            </Typography>
}

            {[1, 2].map((i) =>
              partialData?.length > 0 ? (
                <Typography key={i} className="top-pick-text" style={{ fontSize: "10px", whiteSpace: "nowrap", margin: "0px 0px clamp(3px, 1%, 12px)", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold", width: "100%" }}>
                  <Skeleton.Input active size="small" block style={{ width: "100%", height: "20px", borderRadius: "0" }} />
                </Typography>
              ) : labels?.[`feature_${i}_description`] ? (
                <Typography
                  key={i}
                  className="top-pick-text"
                  style={{
                    fontSize: "10px",
                    wordBreak: "break-word",
                    margin: "0px 0px clamp(8px, 1%, 12px)",
                    fontWeight: "bold",
                    lineHeight: "1.3",
                    color: "rgb(51, 51, 51)",
                    width: "100%",
                    background: i % 2 !== 0 ? "#ededed" : "white",
                    textAlign: "left",
                    padding: "4px"
                  }}
                >
                  <Tooltip title={labels[`feature_${i}_description`]}>{labels[`feature_${i}_description`]}</Tooltip>
                </Typography>
              ) : (
                <Skeleton.Input key={i} active size="small" style={{ width: "100%", height: "20px", borderRadius: "0" }} />
              )
            )}

            <div
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                background: "#ededed",
                color: "black",
                fontSize: "10px",
                fontWeight: "bold",
                padding: "4px",
                borderRadius: "0px 0px 4px 4px",
                whiteSpace: "nowrap",
                zIndex: 10,
                height: "40px",
                width: "101%",
                wordWrap: "break-word",
                alignContent: "center",
                textAlign: "left",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {featureKey || product?.["best_for_label"]}
            </div>

          </Box>
        )}
      </div>
    </Card>
  );
};

export default ComparisonProductCard;